import { render, staticRenderFns } from "./OrganizationTag.vue?vue&type=template&id=de54c422&scoped=true&"
import script from "./OrganizationTag.vue?vue&type=script&lang=js&"
export * from "./OrganizationTag.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationTag.vue?vue&type=style&index=0&id=de54c422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de54c422",
  null
  
)

export default component.exports